import { useTranslation } from 'localization/useTranslation';
import { Flex, Tooltip } from '@patternfly/react-core';
import Icons, { Size } from 'components/Common/Icons';
import { formatValueWithUnit, limitDecimals } from 'components/Value/utils';
import { formatTelemetryUnit } from 'utils/dtdl';
import { formatTimestamp } from 'utils/time';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import React from 'react';

const CompactTelemetryInfo = ({ telemetrySchema }) => {
  const T = useTranslation();

  return (<>
    <Flex alignItems={{ default: 'alignItemsCenter' }} justifyContent={{ default: 'justifyContentSpaceBetween' }}>
      <h4 >{ telemetrySchema.displayName || telemetrySchema.name }</h4>
      { telemetrySchema.description &&
        <Tooltip
          content={telemetrySchema.description}
        >
          <Icons.Info size={Size.SMALL}/>
        </Tooltip>
      }
    </Flex>
    <p className="telemetry-card-value">
      { formatValueWithUnit(limitDecimals(telemetrySchema?.value?.value), T.localize(formatTelemetryUnit(telemetrySchema?.unit))) }
    </p>
    <p>
      { formatTimestamp(DateTime.fromISO(telemetrySchema?.value?.timestamp)) }
    </p>
  </>);
};

CompactTelemetryInfo.propTypes = {
  telemetrySchema: PropTypes.shape({
    displayName: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    value: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      timestamp: PropTypes.string
    }),
    unit: PropTypes.string,
    componentName: PropTypes.string
  }).isRequired
};

export default CompactTelemetryInfo;
